import { gql } from "@apollo/client";

export default gql`
  mutation createCouponCode($data: CreateCouponCodeInput!){
    createCouponCode(data: $data){
        success
        data{
            _id
            customer
            name
            code
            status
            valueType
            value
            maxRedemptions
            timesRedeemed
            usageType
            usageLimit
            usageCount
            expiredAt
            createdAt
            updatedAt
        }
        code
        message
    }
}
`
